import { render, staticRenderFns } from "./ClientePerfilView.vue?vue&type=template&id=bd753fbe&scoped=true"
import script from "./ClientePerfilView.vue?vue&type=script&lang=js"
export * from "./ClientePerfilView.vue?vue&type=script&lang=js"
import style0 from "./ClientePerfilView.vue?vue&type=style&index=0&id=bd753fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd753fbe",
  null
  
)

export default component.exports